import { render, staticRenderFns } from "./Enviar.vue?vue&type=template&id=7b39d7cf"
import script from "./Enviar.vue?vue&type=script&lang=js"
export * from "./Enviar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports